export default function Footer() {
  const handleLinkClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    } else if (href === '#') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-secondary-950 text-secondary-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-16 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">

          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-heading text-secondary-100">爱豆影视</span>
            </div>
            <p className="text-sm text-secondary-400 leading-relaxed mb-4">
              爱豆影视致力于提供高清不缓冲流畅播放体验，汇聚最新热播电视剧、电影、综艺高分全集，免费在线观看不卡顿。每日更新，让好剧不等待。
            </p>
            <div className="flex items-center gap-3">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-weibo-line text-base"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-base"></i>
              </span>
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-secondary-800 text-secondary-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer">
                <i className="ri-bilibili-line text-base"></i>
              </span>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-secondary-100 mb-4">
              <a href="#updates" onClick={(e) => handleLinkClick(e, '#updates')} className="hover:text-primary-400 transition-colors cursor-pointer">快速导航</a>
            </h4>
            <ul className="space-y-2.5">
              {[
                { label: '最新动态', href: '#updates' },
                { label: '热门话题', href: '#topics' },
                { label: '精彩专题', href: '#carousel' },
                { label: '常见问题', href: '#faq' },
                { label: '热播榜单', href: '#ranking' },
              ].map((item) => (
                <li key={item.href}>
                  <a
                    href={item.href}
                    onClick={(e) => handleLinkClick(e, item.href)}
                    className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-secondary-100 mb-4">内容分类</h4>
            <ul className="space-y-2.5">
              {['热播电视剧', '高分电影', '热门综艺', '动漫番剧', '纪录片', '少儿内容'].map((item) => (
                <li key={item}>
                  <span className="text-sm text-secondary-400 hover:text-primary-400 transition-colors cursor-pointer">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-secondary-100 mb-4">合作伙伴</h4>
            <p className="text-sm text-secondary-500 leading-relaxed">
              爱豆影视与多家优质内容平台保持友好合作关系，持续为观众带来丰富的影视资源与流畅的高清播放体验。
            </p>
            <div className="mt-4">
              <a
                href="#contact"
                onClick={(e) => handleLinkClick(e, '#contact')}
                className="inline-flex items-center gap-1.5 text-sm text-primary-400 hover:text-primary-300 transition-colors cursor-pointer"
              >
                <i className="ri-mail-line"></i>
                联系我们
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-800 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-secondary-500">
            &copy; {new Date().getFullYear()} 爱豆影视。高清流畅，永久免费。本站所有内容均来自互联网公开资源。
          </p>
          <div className="flex items-center gap-4 text-xs text-secondary-500">
            <span className="cursor-pointer hover:text-primary-400 transition-colors">服务条款</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors">隐私政策</span>
            <span className="cursor-pointer hover:text-primary-400 transition-colors">版权声明</span>
          </div>
        </div>
      </div>
    </footer>
  );
}